import Chat from './Chat';
import ChatHeader from './ChatHeader';
import { setChatState, setIsMoreChatMenuShown } from '../actions/ucmaActions';
import { getMoreChats, getVisibleChats } from '../chatManager/chatFilters';
import terminateChatSession from '../services/terminateChatSession';
import { getStore } from '../store/ucmaStore';
import ChatState from '../store/schema/ChatState';
import type ChatViewState from '../store/schema/ChatViewState';
import { observer } from 'mobx-react-lite';
import { ActionButton } from '@fluentui/react/lib/Button';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
    ContextualMenu,
    IContextualMenuItem,
    DirectionalHint,
} from '@fluentui/react/lib/ContextualMenu';

const styles = require('./ChatTabBar.scss');
let chatWrapperDiv: HTMLDivElement;

export default function mountChatTabBar() {
    // Initialize it and append it to the body.
    if (!chatWrapperDiv) {
        chatWrapperDiv = document.createElement('div');
        chatWrapperDiv.className = styles.chatWrapper;
        document.body.appendChild(chatWrapperDiv);
        ReactDOM.render(
            <React.StrictMode>
                <ChatTabBar />
            </React.StrictMode>,
            chatWrapperDiv
        );
    }
}

const ChatTabBar = observer(function ChatTabBar() {
    const moreChatButton = React.useRef<HTMLDivElement>(null);
    const activeChats = getVisibleChats();
    const moreChats = getMoreChats();
    const unreadMoreChats = moreChats.filter(
        chat => chat.lastMessageSequence != chat.lastReadMessageSequence
    );
    const store = getStore();

    return (
        <>
            <div ref={moreChatButton} className={styles.moreChatButton}>
                {moreChats.length > 0 && (
                    <ActionButton onClick={showMoreChats} className={styles.moreButton}>
                        {'+' + moreChats.length}
                        {unreadMoreChats.length > 0 && (
                            <div className={styles.unreadCount}>{unreadMoreChats.length}</div>
                        )}
                    </ActionButton>
                )}
                {store.isMoreChatMenuShown && (
                    <ContextualMenu
                        shouldFocusOnMount={true}
                        target={moreChatButton.current}
                        items={getMoreChatMenuItems()}
                        onDismiss={hideMoreChats}
                        directionalHint={DirectionalHint.leftBottomEdge}
                        styles={{
                            container: styles.moreChatContainer,
                        }}
                    />
                )}
            </div>
            {activeChats.map(chat => (
                <Chat key={chat.chatId} chatViewState={chat} />
            ))}
        </>
    );
});

function showMoreChats() {
    setIsMoreChatMenuShown(true /*isShown*/);
}

function hideMoreChats() {
    setIsMoreChatMenuShown(false /*isShown*/);
}

const onClickHeader = (chat: ChatViewState) => () => {
    setChatState(chat, ChatState.Normal);
    setIsMoreChatMenuShown(false /*isShown*/);
};

const onClickClose = (chat: ChatViewState) => () => {
    terminateChatSession(chat.sessionId);
    setChatState(chat, ChatState.Closed);
};

function getMoreChatMenuItems(): IContextualMenuItem[] {
    const moreChats = getMoreChats();
    return moreChats.map(chat => {
        return {
            key: chat.chatId.toString(),
            data: chat,
            onRender: () => (
                <ChatHeader
                    linkedChatViewState={chat}
                    onClickHeader={onClickHeader(chat)}
                    onClickClose={onClickClose(chat)}
                />
            ),
        };
    });
}
